import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Inline } from 'chaoskit/src/components';

import Hero from '../Hero';
import { Icon } from '../../components';

const ChaosEngineeringHero = ({ children, className, article, ...opts }) => {
  const classes = cx(
    'chaosEngineering__hero',
    'u-bgChaosEngineering',
    { 'u-flexTop': article },
    className
  );

  return (
    <Hero particles={false} compact contrast className={classes} {...opts}>
      <div className="hero-content">
        <div className="container">
          {article && (
            <Inline className="u-textSmall">
              <a className="u-link" href="/chaos-engineering/">
                Chaos Engineering
              </a>
              <Icon size="small" className="u-textMuted" icon="caret-right" />
              <span>{article}</span>
            </Inline>
          )}
          {children}
        </div>
      </div>
    </Hero>
  );
};

ChaosEngineeringHero.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  article: PropTypes.string,
};

export default ChaosEngineeringHero;
